(function ( $ ) {
	$.fn.imagetextswitcher = function () { 
		var $elem = $( this ),
		    $img = $elem.find( '.hero__image' ),
		    $string = $elem.find( '.js-switched-text '),
		    currentIndex = 0,
		    intervalLength = 2000, // time between switches, in ms
		    intervalId,
		    content = [];


		var init = function () {

			if(typeof(text_switcher) !== 'undefined') {
				content = text_switcher.switch_array;
			}

			// Bail if no content
			if(!content.length) {
				return;
			}

			    cacheImages();
			    setCSS();

			    intervalId = window.setInterval(
				    switchImage,
				    intervalLength
			    );


		    },
		    cacheImages = function () {

			    $.each( content, function( image ) {
				    // Cache each image, to avoid the flash of contnet
				    new Image().src = image.src;
			    } );

		    },
		    setCSS = function () {
			    $elem.css({
				    transition: intervalLength + 'ms'
			    });
		    },
		    switchImage = function () {

			    incrementIndex();

			    updateString();
			    updateImage();

		    },
		    incrementIndex = function () {

			    if ( currentIndex === ( content.length - 1 ) ) {
				    currentIndex = 0;
			    } else {
				    currentIndex += 1;
			    }

		    },
		    updateString = function () {

			    $string.text(content[currentIndex].string);

		    },
		    updateImage = function () {

			    $img.attr('src', content[currentIndex].src);

			    if ( $elem.css('background-image') != null ) {
				    $elem.css({
					    'background-image' : 'url(' + content[currentIndex].src + ')'
				    });
			    }

		    };

		init();
		return this;
	};

}( $ ));